var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("editor", {
        staticClass: "json-editor",
        attrs: { lang: "javascript", theme: "dawn", height: "200px" },
        on: { init: _vm.editorInit },
        model: {
          value: _vm.text,
          callback: function($$v) {
            _vm.text = $$v
          },
          expression: "text"
        }
      }),
      _vm._v(" "),
      _vm.error
        ? _c("error-message", {
            attrs: { message: "Invalid json!", fieldName: "json-editor" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }